import styled from 'styled-components';
import { SlideWrapper } from '../../styles/GlobalComponents';

export const ProductSlider = styled(SlideWrapper)`
  min-width: 0;
  .swiper {
    padding-bottom: 32px;
  }
  .swiper-wrapper {
    align-items: stretch;
  }
  .swiper-slide {
    height: auto;
    > article {
      height: 100%;
    }
  }
  && .swiper-pagination {
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    height: 16px;
  }
  && .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
    width: 7px;
    height: 7px;
    margin: 0;
    border-radius: 20px;
    background: #d8d2c9;
    opacity: 1;
    transition: width 150ms, background 150ms;
  }
  &&
    .swiper-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet-active {
    width: 23px;
    background: var(--resource-gold);
  }
`;

export const View = styled.div`
  margin: 20px 0;
  min-height: 640px;
  padding-bottom: 70px;
  position: relative;
  width: 100%;

  @media (min-width: 800px) {
    max-width: 1500px;
    padding: 0 100px;
  }
  @media only screen and (max-width: 1500px) and (min-width: 800px) {
    zoom: 80%;
  }
`;

export const ResourcesContainer = styled.div`
  background: ${({ theme }) => theme.colors.neutral100};
  padding: 20px;
  border-radius: 10px;
  width: 100%;
`;

export const ResourcesHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderIcon = styled.div`
  width: 32px;
  height: 32px;
  background: ${(props) => props.theme.colors.primary900};
  box-sizing: border-box;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Resource = styled.a`
  color: #5a5a5a;
  font-size: 16px;
  line-height: 24px;
  margin-top: 20px;
  border: 1px solid ${(props) => props.theme.colors.neutral900};
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
`;

export const Title = styled.div`
  font-size: 22px;
  font-weight: 800;
  margin-left: 16px;
`;

export const ResourceLayout = styled.div`
  --resource-gold: #ae8e66;
  color: #373737;
  padding-bottom: 24px;
  a {
    text-decoration: none;
  }
  a:focus-visible {
    outline: 3px solid var(--resource-gold);
    outline-offset: 4px;
  }
  a[aria-disabled='true'] {
    cursor: default;
  }
`;

export const ResourceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 22px;
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 600px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }
`;

export const ProductCard = styled.article`
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 20px;
  overflow: hidden;
`;

export const ProductBanner = styled.div<{ $image: string }>`
  height: 140px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: linear-gradient(0deg, #00754f 0%, #102534e8 22%, transparent 65%),
    url('${({ $image }) => $image}') center 38% / cover;
  border-bottom: 2px solid #009563;
  color: #fff;
  span {
    font-size: 12px;
    font-weight: 700;
    color: #ddd;
  }
  h4 {
    margin: 5px 0 0;
    font-family: 'Nulshock';
    font-size: clamp(16px, 1.5vw, 23px);
    line-height: 1.25;
  }
  @media (max-width: 600px) {
    height: 160px;
    h4 {
      font-size: 22px;
    }
  }
`;

export const ProductBody = styled.div`
  padding: 14px 18px 18px;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 14px;
  > p {
    margin: 0;
    font-size: 16px;
    line-height: 1.3;
    min-height: 40px;
  }
  > div {
    display: flex;
    flex-direction: column;
    gap: 7px;
    margin-top: auto;
  }
`;

export const ResourceAction = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 40px;
  padding: 8px 12px;
  border-radius: 11px;
  background: #f4f4f4;
  color: #262626;
  font-size: 16px;
  line-height: 1.3;
  transition: background 150ms;
  &[href]:hover {
    background: #ece7df;
  }
`;

export const ActionIcon = styled.span`
  flex-shrink: 0;
  width: 25px;
  height: 25px;
  border-radius: 7px;
  background: var(--resource-gold);
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 23px;
`;

export const PrimaryAction = styled(ResourceAction)`
  justify-content: center;
  min-height: 45px;
  background: var(--resource-gold);
  color: #fff;
  font-weight: 600;
  &[href]:hover {
    background: #977850;
  }
  > span {
    font-size: 21px;
    line-height: 1;
  }
`;

export const Benefits = styled.ul`
  list-style: none;
  padding: 9px 13px;
  margin: 0;
  border-radius: 11px;
  background: #f4f4f4;
  display: grid;
  gap: 7px;
  li {
    display: flex;
    align-items: center;
    gap: 9px;
    font-size: 15px;
    line-height: 1.3;
  }
  span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    border-radius: 50%;
    color: white;
    background: var(--resource-gold);
  }
`;

export const StoreIcons = styled.span`
  display: flex;
  gap: 5px;
  a {
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000;
    border-radius: 6px;
  }
  img {
    width: 18px;
    height: 18px;
    object-fit: contain;
  }
`;

export const ResourceSection = styled.section`
  margin-top: 60px;
  @media (max-width: 600px) {
    margin-top: 36px;
  }
`;

export const DocumentCard = styled.article<{ $wide?: boolean }>`
  grid-column: ${({ $wide }) => ($wide ? 'span 2' : 'span 1')};
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 285px;
  padding: 26px;
  border: 1px solid #ebebeb;
  border-radius: 20px;
  background: #fff;
  > a {
    margin-top: auto;
  }
  @media (max-width: 600px) {
    grid-column: span 1;
    min-height: 260px;
    padding: 22px;
  }
`;

export const DocumentHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  small {
    display: block;
    font-size: 10px;
    letter-spacing: 1px;
    line-height: 1.5;
    color: #626262;
  }
  h4 {
    margin: 4px 0 0;
    font-size: 20px;
    line-height: 1.2;
    font-weight: 600;
    color: var(--resource-gold);
  }
`;

export const DocumentBadge = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #efe4d0;
  color: var(--resource-gold);
  font-weight: 700;
  font-size: 16px;
`;

export const DocumentDescription = styled.p`
  margin: 15px 0;
  font-size: 16px;
  line-height: 1.4;
`;

export const LanguageList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-bottom: 28px;
  span {
    padding: 6px 12px;
    border-radius: 20px;
    background: #f4f4f4;
    font-size: 13px;
    line-height: 1.2;
  }
  span:last-child {
    background: #efe4d0;
    color: #977850;
  }
`;

export const SocialCard = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  gap: 26px;
  min-height: 140px;
  padding: 26px;
  border: 1px solid #ebebeb;
  border-radius: 20px;
  background: #fff;
  color: #262626;
  transition: border-color 150ms;
  &[href]:hover {
    border-color: var(--resource-gold);
  }
  h4 {
    margin: 0 0 7px;
    font-size: 21px;
    font-weight: 700;
  }
  p {
    margin: 0;
    font-size: 15px;
    color: #929292;
  }
  > span:last-child {
    position: absolute;
    right: 24px;
    top: 20px;
    color: var(--resource-gold);
    font-size: 23px;
  }
  @media (max-width: 600px) {
    min-height: 120px;
  }
`;

export const SocialIcon = styled.span<{ $platform: string }>`
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${({ $platform }) =>
    $platform === 'youtube'
      ? '#ff0000'
      : $platform === 'telegram'
      ? '#00afe8'
      : 'transparent'};
  img {
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
`;
